import { type ReactNode } from "react";

import { Flex } from "@/shared-web.ui/ui.flex";
import { Grid } from "@/shared-web.ui/ui.grid";

import { AppContainer } from "../ui.app-container";

interface HeaderProps {
  children: ReactNode;
}
const Header = (props: HeaderProps) => {
  const { children } = props;

  return (
    <AppContainer
      my="6"
    >
      <Flex
        align={{
          initial: "end",
          xs: "start",
        }}
        direction={{
          initial: "column",
          xs: "row",
        }}
        gap="2"
        justify="between"
      >
        {children}
      </Flex>
    </AppContainer>
  );
};

interface HeaderCategoryProps {
  children: ReactNode;
}
const HeaderCategory = (props: HeaderCategoryProps) => {
  const { children } = props;

  return (
    <Flex
      className={`
        w-full
        xs:w-auto
      `}
      direction="column"
      gap="1"
    >
      {children}
    </Flex>
  );
};

interface HeaderFacetProps {
  children: ReactNode;
}
const HeaderFacet = (props: HeaderFacetProps) => {
  const { children } = props;

  return (
    <Flex
      direction="row"
      gap="5"
    >
      {children}
    </Flex>
  );
};

interface HeaderRefinementProps {
  children: ReactNode;
}
const HeaderRefinement = (props: HeaderRefinementProps) => {
  const { children } = props;

  return (
    <Flex
      direction="column"
      gap="2"
      justify="end"
      align="end"
    >
      {children}
    </Flex>
  );
};

interface BodyProps {
  children: ReactNode;
}
const Body = (props: BodyProps) => {
  const { children } = props;

  return (
    <AppContainer>
      <Grid
        columns="2"
        gap={{
          initial: "2",
          sm: "6",
        }}
      >
        {children}
      </Grid>
    </AppContainer>
  );
};
interface BodyColumnProps {
  children: ReactNode;
}
const BodyColumn = (props: BodyColumnProps) => {
  const { children } = props;

  return (
    <Flex
      direction="column"
      gap={{
        initial: "2",
        sm: "6",
      }}
    >
      {children}
    </Flex>
  );
};

const LayoutProductList = {
  Header,
  HeaderCategory,
  HeaderFacet,
  HeaderRefinement,

  Body,
  BodyColumn,
};

export { LayoutProductList };
